import {
    createAsyncThunk,
    createSelector,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit'
import api from '../../utils/api'
import {
    RetrieveMeetingVideocallResponse,
    UpdateVideocallResponse
} from '../../types/__generated_swagger'
import { RootState } from '../../store'
import { websocketAction } from '../../utils/redux'

interface FetchMeeting {
    eventSlug: string
    meetingSlug: string
    twilioName: string
}

const WS = {
    updatedCall: websocketAction<UpdateVideocallResponse>('updated_videocall'),
}

export const fetchMeetingVideocall = createAsyncThunk(
    'FETCH_MEETING_VIDEOCALL',
    ({ eventSlug, meetingSlug, twilioName }: FetchMeeting) => (
        api.get<RetrieveMeetingVideocallResponse>(
            `/events/${eventSlug}/meetings/${meetingSlug}/meetings/${twilioName}/`
        )
    )
)

const currentMeetingSlice = createSlice({
    name: 'currentMeetingSlice',
    initialState: {
        meeting: null as RetrieveMeetingVideocallResponse,
        gotKicked: false
    },

    reducers: {
        setGotKicked: (state, { payload }: PayloadAction<boolean>) => {
            state.gotKicked = !!payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMeetingVideocall.fulfilled, (state, { payload }) => {
            state.meeting = payload
        })
        builder.addCase(fetchMeetingVideocall.rejected, () => null)
        builder.addCase(WS.updatedCall, (state, { payload }: PayloadAction<UpdateVideocallResponse>) => {
            // Might be null if we didnt fetch current meeting yet
            if (state) {
                state.meeting.users = payload.users
            } else {
                // This prevents error:
                // A case reducer on a non-draftable value must not return undefined
                return null
            }
        })
    },
})

export const selectCurrentMeeting = (state: RootState) => state.meeting.current.meeting
export const selectIsMeeting = (state: RootState) => !!state.meeting.current.meeting
export const selectGotKicked = (state: RootState) => state.meeting.current.gotKicked
export const selectMeetingHost = (state: RootState) => state.meeting.current?.meeting?.host_id
export const selectIsMeetingHost = createSelector(
    [
        (state: RootState) => state.meeting?.current?.meeting?.host_id,
        (state: RootState) => state.auth.user?.id,
    ],
    (hostId, userId) => hostId === userId,
)

export const setGotKicked = currentMeetingSlice.actions.setGotKicked
export default currentMeetingSlice.reducer
